import React, { useState } from "react";
import { Breadcrumb } from "antd";
import { useSelector, connect } from "react-redux";
import BarcodePrintList from "./BarcodePrintList";

const BarcodePrint = ({ auth }) => {
  const [updatelist, setUpdatelist] = useState(true);

  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Product</Breadcrumb.Item>
        <Breadcrumb.Item>Barcode</Breadcrumb.Item>
        <Breadcrumb.Item>Print List</Breadcrumb.Item>
      </Breadcrumb>

      <div className="site-layout-background main-frame">
        <BarcodePrintList
          updatelist={updatelist}
          setUpdatelist={setUpdatelist}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(BarcodePrint);
